module.exports = __webpack_public_path__ + "static/media/boop_game.496a0186.jpg";